import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { useEffect, useMemo } from "react";
import { FlowActions } from "../../stores/flowStore";
export const useSetItemImageMapFragment = graphql(`
  fragment useSetItemImageMap on ItemQuoteResult {
    __typename
    ... on ItemQuote {
      item {
        id
        imageUrl
      }
    }
  }
`);
export function useSetItemImageMap(itemQuoteKeys) {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] !== itemQuoteKeys) {
    t1 = itemQuoteKeys?.reduce(_temp, {}) ?? {};
    $[0] = itemQuoteKeys;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  t0 = t1;
  const itemImageMap = t0;
  let t2;
  let t3;
  if ($[2] !== itemImageMap) {
    t2 = function setItemImageMapInFlowStore() {
      FlowActions.setItemImageMap(itemImageMap);
    };
    t3 = [itemImageMap];
    $[2] = itemImageMap;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  return itemImageMap;
}
function _temp(acc, itemQuoteKey) {
  const itemQuote = readFragment(useSetItemImageMapFragment, itemQuoteKey);
  if (itemQuote.__typename !== "ItemQuote") {
    return acc;
  }
  return {
    ...acc,
    [itemQuote.item.id]: itemQuote.item.imageUrl
  };
}